export default __webpack_public_path__ + "static/media/filterList.8b684cb3.svg";